"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rensouApi = require("@/api/rensou/rensouApi");
var _rsManagement = require("@/api/rsManagement");
var _BaseInfoForm = _interopRequireDefault(require("./components/BaseInfoForm.vue"));
var _SpecStockForm = _interopRequireDefault(require("./components/SpecStockForm.vue"));
var _Other = _interopRequireDefault(require("./components/Other.vue"));
var _DateParameter = _interopRequireDefault(require("./components/DateParameter.vue"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RsGoodsAdd',
  components: {
    BaseInfoForm: _BaseInfoForm.default,
    SpecStockForm: _SpecStockForm.default,
    Tinymce: _Tinymce.default,
    Other: _Other.default,
    DateParameter: _DateParameter.default
  },
  data: function data() {
    var _this = this;
    return {
      currentStep: 0,
      pageLoading: false,
      specStockData: {},
      // 编辑页面父传子的数据
      attrType: 'single',
      // single, multi, sku
      singleSpecForm: {
        price: 0,
        otPrice: 0,
        costPrice: 0,
        stock: undefined,
        stockWarning: 0,
        minQuantity: 1,
        maxQuantity: 999,
        barCode: '',
        skuCode: '',
        weight: '',
        volumeLong: '',
        volumeWide: '',
        volumeHigh: ''
      },
      multipleAttr: {},
      attr: [],
      attrValue: [],
      // SKU模式下的规格组合数据

      // 商品信息表单
      goodsForm: {
        storeId: '',
        cateId: '',
        showCateId: [],
        // 修改为数组类型以支持多选
        spuName: '',
        sort: '',
        brandId: '',
        branName: '',
        status: 1,
        isMust: 0,
        appointmentTimeFlag: 1,
        spuCode: '',
        tags: [],
        labelId: '',
        labelName: '',
        wmTgFlag: '',
        storeType: '',
        frtTemplateId: undefined,
        validityFlag: 1,
        validityDays: 0,
        validityStartTime: '',
        validityEndTime: '',
        serviceType: [],
        image: '',
        sliderImage: [] // 修改为数组以支持多张轮播图
      },
      goodsRules: {
        storeId: [{
          required: true,
          message: '请选择店铺',
          trigger: 'change'
        }],
        cateId: [{
          required: true,
          message: '请选择商品分类',
          trigger: 'change'
        }],
        wmTgFlag: [{
          required: true,
          message: '请选择购买方式',
          trigger: 'change'
        }],
        storeType: [{
          validator: function validator(rule, value, callback) {
            if (!_this.goodsForm.storeId || !_this.goodsForm.wmTgFlag) {
              callback();
              return;
            }
            if (value === null || value === undefined || value === '') {
              callback(new Error('请选择店铺类型'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }],
        showCateId: [{
          required: true,
          message: '请选择展示分类',
          trigger: 'change'
        }],
        spuName: [{
          required: true,
          message: '请输入SPU名称',
          trigger: 'blur'
        }],
        sort: [{
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) {
              callback();
              return;
            }
            var str = String(value).trim();
            if (!/^-?\d+$/.test(str)) {
              callback(new Error('排序必须为整数，不能为小数'));
              return;
            }
            callback();
          },
          trigger: ['blur', 'change']
        }],
        status: [{
          required: true,
          message: '请选择商品状态',
          trigger: 'change'
        }],
        isMust: [{
          required: true,
          message: '请选择是否必选商品',
          trigger: 'change'
        }],
        appointmentTimeFlag: [{
          required: true,
          message: '请选择购买是否预约时间',
          trigger: 'change'
        }, {
          validator: function validator(rule, value, callback) {
            if (Number(_this.goodsForm.wmTgFlag) !== 2) return callback();
            if (value === null || value === undefined || value === '') {
              return callback(new Error('请选择购买是否预约时间'));
            }
            callback();
          },
          trigger: 'change'
        }],
        validityFlag: [{
          validator: function validator(rule, value, callback) {
            if (Number(_this.goodsForm.wmTgFlag) !== 2 || Number(_this.goodsForm.appointmentTimeFlag) === 1) {
              callback();
              return;
            }
            if (value === null || value === undefined || value === '') {
              callback(new Error('请选择商品有效期'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }],
        serviceType: [{
          required: true,
          message: "请选择服务类型",
          trigger: 'change'
        }],
        spuCode: [{
          required: true,
          message: 'SPU编码不能为空',
          trigger: 'blur'
        }]
      },
      storeOptions: [],
      storeTypeOptions: [],
      productStoreTypeOptions: [],
      selectedStoreTypes: [],
      originalStoreId: null,
      // 原商品的店铺ID（用于复制时过滤）
      labelOptions: [],
      categoryOptions: [],
      cascaderProps: {
        checkStrictly: true,
        // 改为true，允许选择任意层级
        value: 'id',
        label: 'name',
        children: 'children',
        emitPath: true // 启用完整路径显示
      },
      displayCategoryOptions: [],
      brandOptions: [],
      content: '',
      purchaseNotice: '',
      useNotice: '',
      parameterList: [],
      // 其他参数数据
      wmTgFlagOptions: [],
      frtTemplateOptions: [],
      frtTemplateFlag: false,
      isWmTg: 1,
      isExpress: false
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.generateSpuCode();
            _context.n = 1;
            return this.initPage();
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    initPage: function () {
      var _initPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.pageLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return Promise.all([this.getGoodsCategoryList(), this.getDisplayCategoryList(), this.getBrand(), this.getStoreLIst(), this.getStoreTypeList(), this.getLabelList()]);
            case 2:
              if (!this.$route.params.id) {
                _context2.n = 3;
                break;
              }
              _context2.n = 3;
              return this.getProductInfo(this.$route.params.id);
            case 3:
              _context2.p = 3;
              this.pageLoading = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1,, 3, 4]]);
      }));
      function initPage() {
        return _initPage.apply(this, arguments);
      }
      return initPage;
    }(),
    wmTgFlagChange: function wmTgFlagChange(val) {
      console.log(val);
      this.isWmTg = Number(val);
    },
    shippingChange: function shippingChange(val) {
      var wmTgFlag = Number(val);
      this.goodsForm.storeType = '';
      this.refreshProductStoreTypeOptions();
      this.goodsForm.appointmentTimeFlag = wmTgFlag === 2 ? 1 : '';
      this.resetValidityFieldsForAppointment();
      if (wmTgFlag === 1 && this.isExpress) {
        this.frtTemplateFlag = true;
        this.shippingDropList();
      } else {
        this.frtTemplateFlag = false;
        this.goodsForm.frtTemplateId = undefined;
      }
    },
    normalizeStoreTypeValue: function normalizeStoreTypeValue(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      var numValue = Number(value);
      return Number.isNaN(numValue) ? String(value) : numValue;
    },
    parseStoreTypes: function parseStoreTypes(value) {
      var _this2 = this;
      if (value === null || value === undefined || value === '') {
        return [];
      }
      var values = Array.isArray(value) ? value : String(value).split(',');
      return values.map(function (item) {
        return _this2.normalizeStoreTypeValue(String(item).trim());
      }).filter(function (item) {
        return item !== '';
      });
    },
    refreshProductStoreTypeOptions: function refreshProductStoreTypeOptions() {
      var _this3 = this;
      var wmTgFlag = this.goodsForm.wmTgFlag === null || this.goodsForm.wmTgFlag === undefined || this.goodsForm.wmTgFlag === '' ? '' : String(this.goodsForm.wmTgFlag);
      if (!wmTgFlag || !this.selectedStoreTypes.length || !this.storeTypeOptions.length) {
        this.productStoreTypeOptions = [];
        // 编辑页详情和下拉接口并发时依赖可能尚未齐全，此时不能清空已回填的店铺类型。
        return;
      }
      var availableStoreTypeIds = new Set(this.selectedStoreTypes.map(function (item) {
        return String(item);
      }));
      this.productStoreTypeOptions = this.storeTypeOptions.filter(function (item) {
        return availableStoreTypeIds.has(String(item.value)) && String(item.businessType) === wmTgFlag;
      });
      if (this.goodsForm.storeType !== null && this.goodsForm.storeType !== undefined && this.goodsForm.storeType !== '' && !this.productStoreTypeOptions.some(function (item) {
        return String(item.value) === String(_this3.goodsForm.storeType);
      })) {
        this.goodsForm.storeType = '';
      }
    },
    getStoreTypeList: function () {
      var _getStoreTypeList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this4 = this;
        var res, list, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _rsManagement.getMerchantStoreTypeList)();
            case 1:
              res = _context3.v;
              list = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
              this.storeTypeOptions = list.map(function (item) {
                return {
                  label: item.value || item.name,
                  value: _this4.normalizeStoreTypeValue(item.key !== undefined ? item.key : item.id),
                  businessType: item.type
                };
              }).filter(function (item) {
                return item.value !== '';
              });
              this.refreshProductStoreTypeOptions();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t = _context3.v;
              console.error('获取店铺类型列表失败:', _t);
              this.$message.error('获取店铺类型列表失败');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getStoreTypeList() {
        return _getStoreTypeList.apply(this, arguments);
      }
      return getStoreTypeList;
    }(),
    loadSelectedStoreTypes: function () {
      var _loadSelectedStoreTypes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(storeId) {
        var selectedStore, res, storeTypesValue, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.selectedStoreTypes = [];
              if (storeId) {
                _context4.n = 1;
                break;
              }
              this.refreshProductStoreTypeOptions();
              return _context4.a(2);
            case 1:
              selectedStore = this.storeOptions.find(function (item) {
                return String(item.value) === String(storeId);
              });
              if (!(selectedStore && selectedStore.storeTypes !== null && selectedStore.storeTypes !== undefined && selectedStore.storeTypes !== '')) {
                _context4.n = 2;
                break;
              }
              this.selectedStoreTypes = this.parseStoreTypes(selectedStore.storeTypes);
              this.refreshProductStoreTypeOptions();
              return _context4.a(2);
            case 2:
              _context4.p = 2;
              _context4.n = 3;
              return (0, _rsManagement.getStoreInfo)(storeId);
            case 3:
              res = _context4.v;
              storeTypesValue = res && res.storeTypes !== null && res.storeTypes !== undefined ? res.storeTypes : res ? res.storeType : '';
              this.selectedStoreTypes = this.parseStoreTypes(storeTypesValue);
              if (selectedStore) {
                this.$set(selectedStore, 'storeTypes', storeTypesValue);
              }
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t2 = _context4.v;
              console.error('获取店铺详情失败:', _t2);
              this.$message.error('获取店铺详情失败');
            case 5:
              _context4.p = 5;
              this.refreshProductStoreTypeOptions();
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4, 5, 6]]);
      }));
      function loadSelectedStoreTypes(_x) {
        return _loadSelectedStoreTypes.apply(this, arguments);
      }
      return loadSelectedStoreTypes;
    }(),
    generateSpuCode: function generateSpuCode() {
      // 自动生成SPU编码逻辑
      this.goodsForm.spuCode = 'SPU' + Date.now();
      this.singleSpecForm.skuCode = 'SKU' + Date.now();
    },
    handlePrev: function () {
      var _handlePrev = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              // 在切换步骤前保存当前步骤的数据
              if (this.currentStep === 1 && this.$refs.specStockForm) {
                // 保存规格库存数据
                try {
                  this.specStockData = this.$refs.specStockForm.getFormData();
                  console.log('上一步时保存的规格数据:', this.specStockData);
                } catch (error) {
                  console.warn('保存规格数据失败:', error);
                }
              }
              if (this.currentStep > 0) {
                this.currentStep--;
              } else {
                // 返回列表页
                this.$router.push({
                  name: 'goodsList'
                });
              }
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handlePrev() {
        return _handlePrev.apply(this, arguments);
      }
      return handlePrev;
    }(),
    handleNext: function () {
      var _handleNext = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var isValid, payload, _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              // 根据当前步骤进行不同的验证
              isValid = true;
              if (!(this.currentStep === 0)) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return this.$refs.baseInfoForm.validate();
            case 1:
              isValid = _context6.v;
              _context6.n = 8;
              break;
            case 2:
              if (!(this.currentStep === 1)) {
                _context6.n = 8;
                break;
              }
              _context6.n = 3;
              return this.$refs.specStockForm.validate();
            case 3:
              isValid = _context6.v;
              if (!(isValid && this.showDateParameter && this.$refs.dateParameterRef)) {
                _context6.n = 7;
                break;
              }
              _context6.p = 4;
              _context6.n = 5;
              return this.$refs.dateParameterRef.validate();
            case 5:
              _context6.n = 7;
              break;
            case 6:
              _context6.p = 6;
              _t3 = _context6.v;
              isValid = false;
            case 7:
              // 在离开第二步时保存规格库存数据
              if (isValid && this.$refs.specStockForm) {
                this.specStockData = this.$refs.specStockForm.getFormData();
              }
            case 8:
              // 第四步其他参数暂无必填校验

              if (isValid) {
                // 打印当前步骤所有已选择/填写的数据
                payload = this.buildCurrentPayload(); // 如果不是第三步就进行下一步如果是的化就是提交保存
                if (this.currentStep < 3) {
                  this.currentStep++;
                } else {
                  // 提交保存
                  // 如果是编辑且不是从“复制”进入，则走更新逻辑；复制应走新增逻辑
                  if (this.$route.params.id && !(this.$route.query && this.$route.query.copy)) {
                    // 编辑商户商品信息
                    this.updateMerchantProduct(payload);
                  } else {
                    // 新增商户商品信息（包括复制创建）
                    this.createMerchantProduct(payload);
                  }
                }
              }
            case 9:
              return _context6.a(2);
          }
        }, _callee6, this, [[4, 6]]);
      }));
      function handleNext() {
        return _handleNext.apply(this, arguments);
      }
      return handleNext;
    }(),
    updateMerchantProduct: function updateMerchantProduct(payload) {
      var _this5 = this;
      this.$loading({
        lock: true,
        text: '正在保存商品信息...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _rensouApi.updateMerchantProduct)(payload).then(function (res) {
        _this5.$closeCompletedView();
        _this5.$loading().close();
        _this5.$message.success('商品保存成功！');
        _this5.$router.push({
          name: 'goodsList'
        });
      }).catch(function (err) {
        _this5.$loading().close();
        console.error('商品保存失败:', err);
      });
    },
    //创建商户商品信息
    createMerchantProduct: function createMerchantProduct(payload) {
      var _this6 = this;
      this.$loading({
        lock: true,
        text: '正在保存商品信息...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _rensouApi.createMerchantProduct)(payload).then(function (res) {
        _this6.$closeCompletedView();
        _this6.$loading().close();
        _this6.$message.success('商品保存成功！');
        _this6.$router.push({
          name: 'goodsList'
        });
      }).catch(function (err) {
        _this6.$loading().close();
        console.error('商品保存失败:', err);
      });
    },
    // 组装当前步骤的表单数据用于打印/提交
    normalizeSort: function normalizeSort(value) {
      var forForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (value === '' || value === null || value === undefined || value === 'null' || value === 'undefined') {
        return forForm ? '' : null;
      }
      var num = Number(value);
      if (!Number.isFinite(num) || !Number.isInteger(num)) {
        return forForm ? '' : null;
      }
      return num;
    },
    buildCurrentPayload: function buildCurrentPayload() {
      var form = this.goodsForm || {};
      var payload = {
        storeId: form.storeId || null,
        cateId: this.processCateIdToString(form.cateId),
        // showCateId:form.showCateId,
        // showCateId:'1,2,3',
        showCateJson: this.processShowCateIdToJson(form.showCateId),
        spuName: form.spuName || '',
        sort: this.normalizeSort(form.sort),
        brandId: form.brandId || null,
        brandName: form.brandName || '',
        status: form.status,
        // status:1,
        isMust: form.isMust,
        appointmentTimeFlag: Number(form.wmTgFlag) === 2 && Number(form.appointmentTimeFlag) === 1 ? 1 : 0,
        spuCode: form.spuCode || '',
        labelId: form.labelId || '',
        labelName: form.labelName || '',
        wmTgFlag: form.wmTgFlag || null,
        storeType: form.storeType || null,
        frtTemplateId: form.frtTemplateId || undefined,
        validityFlag: form.validityFlag || 1,
        validityDays: form.validityFlag === 2 ? form.validityDays : undefined,
        validityStartTime: form.validityFlag === 3 ? form.validityStartTime : undefined,
        validityEndTime: form.validityFlag === 3 ? form.validityEndTime : undefined,
        serviceType: Array.isArray(form.serviceType) ? form.serviceType.join(',') : form.serviceType || '',
        image: form.image || '',
        sliderImage: form.sliderImage || ''
      };

      // 如果是第二步或之后，添加规格库存数据
      if (this.currentStep >= 1 && this.specStockData) {
        // 将规格库存数据解包到payload中
        Object.assign(payload, this.specStockData);
      }

      // 如果是第三步或之后，添加商品详情数据
      if (this.currentStep >= 2) {
        payload.description = this.content || '';
        payload.purchaseNotice = this.purchaseNotice || '';
        payload.useNotice = this.useNotice || '';
      }

      // 第四步添加商品参数
      if (this.currentStep >= 3) {
        payload.parameterList = this.parameterList;
      }
      this.appendDateParameterPayload(payload);

      // 在编辑模式下默认带上 id，但如果是从“复制”进入（route.query.copy）则不传 id
      if (this.$route.params.id && !(this.$route.query && this.$route.query.copy)) {
        payload.id = this.$route.params.id;
      }

      // 如果是同步模式，添加同步店铺 ID
      if (this.$route.query && this.$route.query.sync && this.$route.query.storeIds) {
        // 将逗号分隔的 storeIds 转换为数组
        payload.syncStoreIds = this.$route.query.storeIds.split(',').map(function (id) {
          return parseInt(id);
        }).filter(function (id) {
          return !isNaN(id);
        });
      }
      console.log('payload', payload);
      return payload;
    },
    appendDateParameterPayload: function appendDateParameterPayload(payload) {
      var _this7 = this;
      if (!this.showDateParameter || !this.$refs.dateParameterRef) return;
      var form = this.goodsForm || {};
      var wmTgFlag = Number(payload.wmTgFlag);
      var getDateData = function getDateData() {
        return _this7.$refs.dateParameterRef.getFormData && _this7.$refs.dateParameterRef.getFormData();
      };
      if (wmTgFlag === 3) {
        var hotelData = getDateData();
        if (hotelData) {
          payload.hotelCheckInTime = hotelData.hotelCheckInTime;
          payload.hotelCheckOutTime = hotelData.hotelCheckOutTime;
          payload.deadlineTime = hotelData.deadlineTime;
          payload.attrValue = hotelData.attrValue;
          payload.hotelExtra = JSON.stringify(hotelData.hotelExtra);
          payload.attrType = 4;
        }
      } else if (wmTgFlag === 2 && Number(form.appointmentTimeFlag) === 1) {
        var dateData = getDateData();
        if (dateData) {
          payload.deadlineTime = dateData.deadlineTime;
          payload.attrValue = dateData.attrValue;
          payload.appointmentExtra = JSON.stringify(dateData.hotelExtra);
          payload.attrType = 4;
        }
      }
    },
    setDateParameterData: function setDateParameterData(data) {
      var _this8 = this;
      this.$nextTick(function () {
        _this8.$nextTick(function () {
          if (_this8.showDateParameter && _this8.$refs.dateParameterRef) {
            _this8.$refs.dateParameterRef.setFormData(data);
          }
        });
      });
    },
    // 获取商品分类数据
    getGoodsCategoryList: function () {
      var _getGoodsCategoryList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res, _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return (0, _rensouApi.getGoodsCategory)();
            case 1:
              res = _context7.v;
              if (res && res.length > 0) {
                this.categoryOptions = this.processTreeData(res);
              }
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t4 = _context7.v;
              console.error('获取商品分类失败:', _t4);
              this.$message.error('获取商品分类失败');
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function getGoodsCategoryList() {
        return _getGoodsCategoryList.apply(this, arguments);
      }
      return getGoodsCategoryList;
    }(),
    // 获取展示分类数据
    getDisplayCategoryList: function () {
      var _getDisplayCategoryList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res, _t5;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              _context8.n = 1;
              return (0, _rensouApi.getDisplayCategory)();
            case 1:
              res = _context8.v;
              if (res && res.length > 0) {
                // 将展示分类处理为级联选择器格式
                this.displayCategoryOptions = this.processTreeData(res);
              }
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t5 = _context8.v;
              console.error('获取展示分类失败:', _t5);
              this.$message.error('获取展示分类失败');
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function getDisplayCategoryList() {
        return _getDisplayCategoryList.apply(this, arguments);
      }
      return getDisplayCategoryList;
    }(),
    getStoreLIst: function () {
      var _getStoreLIst = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res, _t6;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              _context9.n = 1;
              return (0, _rensouApi.getStore)({
                online: 1
              });
            case 1:
              res = _context9.v;
              this.storeOptions = res.map(function (item) {
                return {
                  label: item.value,
                  value: item.key,
                  storeTypes: item.storeTypes !== undefined ? item.storeTypes : item.storeType
                };
              });
              if (!this.goodsForm.storeId) {
                _context9.n = 2;
                break;
              }
              _context9.n = 2;
              return this.loadSelectedStoreTypes(this.goodsForm.storeId);
            case 2:
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t6 = _context9.v;
              console.error('获取商户店铺列表失败:', _t6);
              this.$message.error('获取商户店铺列表失败');
            case 4:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 3]]);
      }));
      function getStoreLIst() {
        return _getStoreLIst.apply(this, arguments);
      }
      return getStoreLIst;
    }(),
    // 获取购买方式列表
    getWmTgFlagList: function () {
      var _getWmTgFlagList2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(storeId) {
        var res, _t7;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              _context0.p = 0;
              _context0.n = 1;
              return (0, _rensouApi.getWmTgFlagList)(storeId);
            case 1:
              res = _context0.v;
              if (res.wmTgFlagList && res.wmTgFlagList.length > 0) {
                this.wmTgFlagOptions = res.wmTgFlagList.map(function (item) {
                  return {
                    label: item.value,
                    value: item.key
                  };
                });
                console.log('获取到的购买方式数据:', this.wmTgFlagOptions);
              } else {
                this.wmTgFlagOptions = [];
              }
              this.isExpress = res.isExpress === 1;
              _context0.n = 3;
              break;
            case 2:
              _context0.p = 2;
              _t7 = _context0.v;
              console.error('获取购买方式列表失败:', _t7);
              this.$message.error('获取购买方式列表失败');
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this, [[0, 2]]);
      }));
      function getWmTgFlagList(_x2) {
        return _getWmTgFlagList2.apply(this, arguments);
      }
      return getWmTgFlagList;
    }(),
    // 获取运费模板列表
    shippingDropList: function () {
      var _shippingDropList2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var res, _t8;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              _context1.n = 1;
              return (0, _rensouApi.shippingDropList)();
            case 1:
              res = _context1.v;
              if (res && res.length > 0) {
                this.frtTemplateOptions = res.map(function (item) {
                  return {
                    label: item.value,
                    value: item.key
                  };
                });
              } else {
                this.frtTemplateOptions = [];
              }
              _context1.n = 3;
              break;
            case 2:
              _context1.p = 2;
              _t8 = _context1.v;
              console.error('获取运费模板列表失败:', _t8);
              this.$message.error('获取运费模板列表失败');
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this, [[0, 2]]);
      }));
      function shippingDropList() {
        return _shippingDropList2.apply(this, arguments);
      }
      return shippingDropList;
    }(),
    handleStoreChange: function () {
      var _handleStoreChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(storeId) {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              this.goodsForm.wmTgFlag = '';
              this.goodsForm.storeType = '';
              this.goodsForm.appointmentTimeFlag = '';
              this.selectedStoreTypes = [];
              this.refreshProductStoreTypeOptions();
              //点击清除不调接口且清除原数据
              if (!storeId) {
                _context10.n = 2;
                break;
              }
              _context10.n = 1;
              return this.loadSelectedStoreTypes(storeId);
            case 1:
              this.getWmTgFlagList(storeId);
              _context10.n = 3;
              break;
            case 2:
              this.wmTgFlagOptions = [];
            case 3:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function handleStoreChange(_x3) {
        return _handleStoreChange.apply(this, arguments);
      }
      return handleStoreChange;
    }(),
    resetValidityFieldsForAppointment: function resetValidityFieldsForAppointment() {
      if (Number(this.goodsForm.wmTgFlag) === 2 && Number(this.goodsForm.appointmentTimeFlag) === 1) {
        this.goodsForm.validityFlag = 1;
        this.goodsForm.validityDays = 0;
        this.goodsForm.validityStartTime = '';
        this.goodsForm.validityEndTime = '';
      }
    },
    getLabelList: function () {
      var _getLabelList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var res, _t9;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              _context11.p = 0;
              _context11.n = 1;
              return (0, _rensouApi.getLabel)();
            case 1:
              res = _context11.v;
              this.labelOptions = res.map(function (item) {
                return {
                  label: item.labelName,
                  value: item.id
                };
              });
              console.log('获取到的标签数据:', this.labelOptions);
              _context11.n = 3;
              break;
            case 2:
              _context11.p = 2;
              _t9 = _context11.v;
              console.error('获取商户商品标签失败:', _t9);
              this.$message.error('获取商户商品标签失败');
            case 3:
              return _context11.a(2);
          }
        }, _callee11, this, [[0, 2]]);
      }));
      function getLabelList() {
        return _getLabelList.apply(this, arguments);
      }
      return getLabelList;
    }(),
    // 获取品牌数据（动态映射为下拉选项）
    getBrand: function () {
      var _getBrand2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var res, _t0;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              _context12.p = 0;
              _context12.n = 1;
              return (0, _rensouApi.getBrand)();
            case 1:
              res = _context12.v;
              if (Array.isArray(res)) {
                this.brandOptions = res.map(function (item) {
                  return {
                    label: item.brandName,
                    value: item.id
                  };
                });
              }
              _context12.n = 3;
              break;
            case 2:
              _context12.p = 2;
              _t0 = _context12.v;
              console.error('获取品牌失败:', _t0);
              this.$message.error('获取品牌失败');
            case 3:
              return _context12.a(2);
          }
        }, _callee12, this, [[0, 2]]);
      }));
      function getBrand() {
        return _getBrand2.apply(this, arguments);
      }
      return getBrand;
    }(),
    // 处理树形数据，确保每个节点都有正确的属性
    processTreeData: function processTreeData(data) {
      var _this9 = this;
      return data.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          children: item.children && item.children.length > 0 ? _this9.processTreeData(item.children) : []
        };
      });
    },
    // 等待分类数据加载完成
    waitForCategoryData: function waitForCategoryData() {
      var _this0 = this;
      return new Promise(function (resolve) {
        var _checkData = function checkData() {
          if (_this0.categoryOptions && _this0.categoryOptions.length > 0) {
            resolve();
          } else {
            setTimeout(_checkData, 100);
          }
        };
        _checkData();
      });
    },
    // 等待标签数据加载完成
    waitForLabelData: function waitForLabelData() {
      var _this1 = this;
      return new Promise(function (resolve) {
        var checkData = function checkData() {
          console.log('bug调试..........', _this1.labelOptions, _this1.labelOptions);
          if (_this1.labelOptions && _this1.labelOptions.length > 0) {
            resolve();
          } else {
            // 如果标签数据为空或不存在，直接resolve继续执行
            console.log('标签数据为空，跳过等待');
            resolve();
          }
        };
        checkData();
      });
    },
    // 根据分类ID查找完整的分类路径
    findCategoryPath: function findCategoryPath(categories, targetId) {
      var currentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var _iterator = _createForOfIteratorHelper(categories),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var category = _step.value;
          // 尝试当前节点
          var newPath = [].concat(_toConsumableArray(currentPath), [category.id]);

          // 如果找到目标ID，返回路径
          if (category.id == targetId) {
            return newPath;
          }

          // 如果有子分类，递归查找
          if (category.children && category.children.length > 0) {
            var foundPath = this.findCategoryPath(category.children, targetId, newPath);
            if (foundPath.length > 0) {
              return foundPath;
            }
          }
        }

        // 未找到匹配项
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return [];
    },
    // cateId
    processCateIdToString: function processCateIdToString(cateId) {
      if (!cateId) {
        return null;
      }

      // 如果是数组，转换为逗号分隔的字符串
      if (Array.isArray(cateId)) {
        return cateId.join(',');
      }

      // 如果已经是字符串或数字，直接返回
      return String(cateId);
    },
    // 将showCateId数组转换为字符串数组格式
    processShowCateIdToJson: function processShowCateIdToJson(showCateId) {
      console.log('原始showCateId数据:', showCateId);
      if (!Array.isArray(showCateId)) {
        console.log('showCateId不是数组，返回空数组');
        return [];
      }
      try {
        var result = showCateId.map(function (item) {
          if (Array.isArray(item)) {
            // 将每个子数组转换为逗号分隔的字符串
            return item.join(',');
          } else {
            // 如果不是数组，直接转换为字符串
            return String(item);
          }
        });
        console.log('转换后的showCateJson:', result);
        return result;
      } catch (error) {
        console.error('转换showCateId时出错:', error);
        return [];
      }
    },
    // 获取商品详情
    getProductInfo: function () {
      var _getProductInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(id) {
        var _this10 = this;
        var res, cateIdValue, cateIdArr, lastCateId, categoryPath, tagsArray, dateAttrValue, _dateAttrValue, _t1;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              _context13.p = 0;
              _context13.n = 1;
              return (0, _rensouApi.getMerchantProductInfo)(id);
            case 1:
              res = _context13.v;
              if (!res) {
                _context13.n = 7;
                break;
              }
              console.log('获取到的商品详情:', res);

              // 如果是复制模式，保存原店铺ID用于过滤
              if (this.$route.query && this.$route.query.copy) {
                this.originalStoreId = res.storeId;
                console.log('复制模式：保存原店铺ID =', this.originalStoreId);
              }

              // 处理商品分类ID字符串转为数组
              cateIdValue = '';
              if (!res.cateId) {
                _context13.n = 3;
                break;
              }
              _context13.n = 2;
              return this.waitForCategoryData();
            case 2:
              // 将逗号分隔的分类ID字符串转换为级联选择器需要的格式
              cateIdArr = res.cateId.split(',');
              if (cateIdArr.length > 0) {
                // 找到最后一级分类ID
                lastCateId = cateIdArr[cateIdArr.length - 1]; // 构建完整的分类路径
                categoryPath = this.findCategoryPath(this.categoryOptions, lastCateId);
                if (categoryPath.length > 0) {
                  cateIdValue = categoryPath;
                } else {
                  // 如果找不到路径，则使用最后一级分类ID
                  cateIdValue = lastCateId;
                }
              }
            case 3:
              console.log('2222222222222222222222');
              // 处理标签数据 - 先等待标签数据加载完成
              _context13.n = 4;
              return this.waitForLabelData();
            case 4:
              console.log('11111111111111111111');
              tagsArray = [];
              if (res.labelId) {
                // 将逗号分隔的标签ID字符串转换为数组
                tagsArray = res.labelId.split(',').map(function (id) {
                  return parseInt(id.trim());
                }).filter(function (id) {
                  return !isNaN(id);
                });
              }
              console.log('333333333333333333');
              // 将获取到的商品详情数据填充到表单中
              this.goodsForm = {
                // 如果是复制模式，清空店铺ID，让用户重新选择
                storeId: this.$route.query && this.$route.query.copy ? '' : res.storeId,
                wmTgFlagOptions: [],
                cateId: cateIdValue,
                showCateId: res.showCateJson || [],
                spuName: res.spuName,
                sort: this.normalizeSort(res.sort, true),
                brandId: res.brandId || '',
                brandName: res.brandName || '',
                status: res.status,
                isMust: res.isMust ? 1 : 0,
                appointmentTimeFlag: res.appointmentTimeFlag !== undefined && res.appointmentTimeFlag !== null ? Number(res.appointmentTimeFlag) === 1 ? 1 : 0 : '',
                spuCode: res.spuCode,
                labelId: res.labelId || '',
                labelName: res.labelName || '',
                tags: tagsArray,
                // 设置标签数组，用于下拉多选框回显
                serviceType: Array.isArray(res.serviceType) ? res.serviceType : res.serviceType ? res.serviceType.split(',').map(function (s) {
                  return s.trim();
                }).filter(function (s) {
                  return s;
                }) : [],
                image: res.image || '',
                wmTgFlag: res.wmTgFlag || null,
                storeType: this.normalizeStoreTypeValue(res.storeType),
                frtTemplateId: res.frtTemplateId || undefined,
                validityFlag: res.validityFlag || 1,
                validityDays: res.validityDays || 0,
                validityEndTime: res.validityEndTime || '',
                validityStartTime: res.validityStartTime || '',
                sliderImage: Array.isArray(res.sliderImage) ? res.sliderImage : []
              };
              if (res.wmTgFlag) {
                this.isWmTg = res.wmTgFlag;
              }
              _context13.n = 5;
              return this.getWmTgFlagList(res.storeId);
            case 5:
              if (!this.goodsForm.storeId) {
                _context13.n = 6;
                break;
              }
              _context13.n = 6;
              return this.loadSelectedStoreTypes(this.goodsForm.storeId);
            case 6:
              console.log('goodsForm', this.goodsForm);
              // 将后端返回的attrType(1,2,3)转换为前端组件需要的格式(single,multi,sku)
              if (res.attrType === 1) {
                this.attrType = 'single';
              } else if (res.attrType === 2) {
                this.attrType = 'multi';
              } else if (res.attrType === 3) {
                this.attrType = 'sku';
              } else {
                this.attrType = 'single'; // 默认单规格
              }

              // 处理规格库存数据
              if (res.singleAttr) {
                // 单规格
                this.singleSpecForm = {
                  price: res.singleAttr.price || 0,
                  otPrice: res.singleAttr.otPrice || 0,
                  costPrice: res.singleAttr.costPrice || 0,
                  stock: res.singleAttr.stock || 0,
                  skuCode: res.singleAttr.skuCode || '',
                  weight: res.singleAttr.weight || '',
                  volumeLong: res.singleAttr.volumeLong || '',
                  volumeWide: res.singleAttr.volumeWide || '',
                  volumeHigh: res.singleAttr.volumeHigh || '',
                  stockWarning: res.singleAttr.stockWarning || 0,
                  barCode: res.singleAttr.barCode || '',
                  minQuantity: res.singleAttr.minQuantity || 0,
                  maxQuantity: res.singleAttr.maxQuantity || 0
                };
              }
              if (res.multipleAttr) {
                this.multipleAttr = res.multipleAttr;
              }
              if (res.attr) {
                this.attr = res.attr;
              }
              if (res.attrValue) {
                // 处理SKU模式下的规格组合数据
                this.attrValue = res.attrValue;
                console.log('add.vue获取到attrValue数据:', res.attrValue);
              }

              // 填充其他步骤的数据
              this.content = res.description || '';
              this.purchaseNotice = res.purchaseNotice || '';
              this.useNotice = res.useNotice || '';

              // 参数列表
              this.parameterList = res.parameterList || [];
              if (Number(res.wmTgFlag) === 3) {
                this.isWmTg = 3;
                dateAttrValue = res.attrValue || [];
                this.singleSpecForm.stockWarning = dateAttrValue.length && dateAttrValue[0].stockWarning !== undefined && dateAttrValue[0].stockWarning !== null ? dateAttrValue[0].stockWarning : 0;
                this.$nextTick(function () {
                  _this10.setDateParameterData({
                    hotelCheckInTime: res.hotelCheckInTime,
                    hotelCheckOutTime: res.hotelCheckOutTime,
                    deadlineTime: res.deadlineTime,
                    hotelExtra: res.hotelExtra ? JSON.parse(res.hotelExtra) : {},
                    dateRange: res.dateRange,
                    price: res.price,
                    costPrice: res.costPrice,
                    stock: res.stock,
                    attrValue: dateAttrValue
                  });
                });
              } else if (Number(res.wmTgFlag) === 2 && Number(res.appointmentTimeFlag) === 1) {
                this.isWmTg = 2;
                _dateAttrValue = res.attrValue || [];
                this.singleSpecForm.stockWarning = _dateAttrValue.length && _dateAttrValue[0].stockWarning !== undefined && _dateAttrValue[0].stockWarning !== null ? _dateAttrValue[0].stockWarning : 0;
                this.$nextTick(function () {
                  var extra = res.appointmentExtra ? typeof res.appointmentExtra === 'string' ? JSON.parse(res.appointmentExtra) : res.appointmentExtra : {};
                  _this10.setDateParameterData({
                    hotelExtra: extra,
                    deadlineTime: res.deadlineTime,
                    dateRange: extra.dateRange || res.dateRange,
                    price: extra.price !== undefined && extra.price !== null ? extra.price : res.price,
                    costPrice: extra.costPrice !== undefined && extra.costPrice !== null ? extra.costPrice : res.costPrice,
                    stock: extra.stock !== undefined && extra.stock !== null ? extra.stock : res.stock,
                    attrValue: _dateAttrValue
                  });
                });
              }
              //购买方式为快递则请求运费模版下拉框接口获取数据回显
              if (!(this.goodsForm.wmTgFlag === 1 && this.isExpress)) {
                _context13.n = 7;
                break;
              }
              this.frtTemplateFlag = true;
              _context13.n = 7;
              return this.shippingDropList();
            case 7:
              _context13.n = 9;
              break;
            case 8:
              _context13.p = 8;
              _t1 = _context13.v;
              console.error('获取商品详情失败:', _t1);
              this.$message.error('获取商品详情失败');
            case 9:
              return _context13.a(2);
          }
        }, _callee13, this, [[0, 8]]);
      }));
      function getProductInfo(_x4) {
        return _getProductInfo.apply(this, arguments);
      }
      return getProductInfo;
    }()
  },
  computed: {
    showDateParameter: function showDateParameter() {
      var wmTgFlag = Number(this.isWmTg);
      return wmTgFlag === 3 || wmTgFlag === 2 && Number(this.goodsForm.appointmentTimeFlag) === 1;
    },
    dateParameterMode: function dateParameterMode() {
      return Number(this.isWmTg) === 3 ? 'hotel' : 'appointment';
    },
    // 过滤后的店铺选项（复制模式下排除原店铺）
    filteredStoreOptions: function filteredStoreOptions() {
      var _this11 = this;
      // 如果是复制模式且有原店铺ID，则过滤掉原店铺
      if (this.$route.query && this.$route.query.copy && this.originalStoreId) {
        return this.storeOptions.filter(function (store) {
          return store.value !== _this11.originalStoreId;
        });
      }
      // 否则返回所有店铺选项
      return this.storeOptions;
    }
  },
  watch: {
    'goodsForm.appointmentTimeFlag': {
      handler: function handler() {
        this.resetValidityFieldsForAppointment();
      }
    },
    content: {
      handler: function handler(newVal) {
        // 商品详情内容变化处理
      },
      deep: true
    },
    parameterList: {
      handler: function handler(newVal) {
        // 参数列表变化处理
      },
      deep: true
    },
    // 监听步骤变化，恢复缓存的规格库存数据
    currentStep: {
      handler: function handler(newStep, oldStep) {
        console.log("\u6B65\u9AA4\u53D8\u5316: ".concat(oldStep, " -> ").concat(newStep));

        // 当回到第2步（规格库存）时，恢复缓存的数据
        if (newStep === 1 && this.specStockData && Object.keys(this.specStockData).length > 0) {
          console.log('回到规格库存步骤，开始恢复缓存数据:', this.specStockData);

          // 恢复规格类型
          if (this.specStockData.attrType !== undefined) {
            var attrTypeMap = {
              1: 'single',
              2: 'multi',
              3: 'sku'
            };
            this.attrType = attrTypeMap[this.specStockData.attrType] || 'single';
            console.log('恢复规格类型:', this.attrType);
          }

          // 恢复规格数据
          if (this.specStockData.attr) {
            this.attr = Array.isArray(this.specStockData.attr) ? _toConsumableArray(this.specStockData.attr) : _objectSpread({}, this.specStockData.attr);
            console.log('恢复attr数据:', this.attr);
          }

          // 恢复SKU组合数据
          if (this.specStockData.attrValue && Array.isArray(this.specStockData.attrValue)) {
            this.attrValue = _toConsumableArray(this.specStockData.attrValue);
            console.log('恢复attrValue数据:', this.attrValue);
          }

          // 恢复多规格数据
          if (this.specStockData.multipleAttr) {
            this.multipleAttr = _objectSpread({}, this.specStockData.multipleAttr);
            console.log('恢复multipleAttr数据:', this.multipleAttr);
          }

          // 恢复单规格数据
          if (this.specStockData.singleAttr) {
            this.singleSpecForm = _objectSpread({}, this.specStockData.singleAttr);
            console.log('恢复singleAttr数据:', this.singleSpecForm);
          }
        }
      },
      immediate: false
    }
  }
};